import React from 'react';

import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';

import {searchPlaygroundRoot} from 'static/three-oh/src/modules/constants/routePaths';

const SearchPlaygroundRoute = (
  <Route
    key="Search Playground"
    path={searchPlaygroundRoot}
    component={
      Loadable({
        loader: () => import(
          /* webpackChunkName: "Search Playground" */
          'static/three-oh/src/routes/Search/containers/SearchBetaContainer'
        ),
        loading: () => null
      })
    }
  />
);

export default SearchPlaygroundRoute;
